import React from 'react';
import PropTypes from 'prop-types';
import ReactRadio from 'react-bootstrap/lib/Radio';
import './Radio.scss';

const Radio = ({
    className, name, disabled, onChange, checked, text
}) => {
    return (
        <div className={ `${ className } fl-indicator` }>
            <ReactRadio
                className={ `${ checked ? 'checked' : '' }` }
                name={ name }
                checked={ checked }
                disabled={ disabled }
                onChange={ onChange }>
                <div>{ text }</div>
                { checked && <div className='fl-tooltip'>{ text }</div> }
            </ReactRadio>
        </div>
    );
};

Radio.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    text: PropTypes.string
};

Radio.defaultProps = {
    className: '',
    name: '',
    checked: false,
    disabled: false,
    onChange: null,
    text: ''
};

export default Radio;
